import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IChecklist2ReportAttentionRequired } from '../../../shared/fi-checklist2-report';
import {
    FiTooltipButtonIconColors,
    FiTooltipIconClassType,
} from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.component';
import { IReportChartData } from '@fi-shared/fi-report-pie-chart/fi-report-pie-chart';

@Component({
    selector: 'fi-deviation-checkpoints-chart',
    templateUrl: './deviation-checkpoints-chart.component.html',
    styleUrls: ['./deviation-checkpoints-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-deviation-checkpoints-chart' },
    standalone: false,
})
export class FiDeviationCheckpointsChartComponent {
    @Input() attentionRequiredList: IChecklist2ReportAttentionRequired[] = [];
    @Input() isLegendTooltipShown: boolean = false;

    getChartData(): IReportChartData[] {
        return [
            {
                gradientColorLight: '#FFDCC4',
                gradientColorBright: '#FF8E1C',
                value: this.getNewDeviationsCount(),
            },
            {
                gradientColorLight: '#FF6454',
                gradientColorBright: '#DE3730',
                value: this.getOldDeviationsCount(),
            },
        ];
    }

    getNewDeviationsCount(): number {
        if (this.attentionRequiredList) {
            return this.attentionRequiredList.reduce((partialSum, item) => partialSum + item.NewAnswers.length, 0);
        }
    }

    getOldDeviationsCount(): number {
        if (this.attentionRequiredList) {
            return this.attentionRequiredList.reduce((partialSum, item) => partialSum + item.OldAnswers.length, 0);
        }
    }

    protected readonly FiTooltipButtonIconColors = FiTooltipButtonIconColors;
    protected readonly FiTooltipIconClassType = FiTooltipIconClassType;
}
